export const filterTasksByDateRange = (tasks, dates, dateField) => {
  if (dates.length === 0) {
    return tasks; // Return all tasks if no date range is selected
  }

  const startDate = new Date(dates[0]);
  const endDate = new Date(dates[dates.length - 1]);

  return tasks.filter((task) => {
    const taskDate = new Date(task[dateField]); // Ensure consistent date parsing
    return taskDate >= startDate && taskDate <= endDate;
  });
};
